import React, { useState } from 'react';
import { X, Upload, Send } from 'lucide-react';
import { toast } from 'react-hot-toast';
import { complianceService } from '../../services/api';

const SubmitVerificationModal = ({ isOpen, onClose, onSubmitted, complianceId }) => {
  const [file, setFile] = useState(null);
  const [reason, setReason] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadedInfo, setUploadedInfo] = useState(null);

  if (!isOpen) return null;

  const handleFileChange = (e) => {
    const selected = e.target.files?.[0] || null;
    setFile(selected);
  };

  const handleUpload = async () => {
    if (!file) {
      toast.error('Please select a file to upload');
      return;
    }
    try {
      setIsUploading(true);
      const res = await complianceService.uploadAttachment(file);
      console.log("res", res)
      if (res?.success) {
        setUploadedInfo(res.data);
        console.log("data", res.data)
        console.log("uploadInfo", uploadedInfo)
        toast.success('File uploaded');
      } else {
        throw new Error('Upload failed');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message || 'Upload failed');
    } finally {
      setIsUploading(false);
      // setUploadedInfo("")
      setFile(null)
    }
  };

  console.log("uploadInfo", uploadedInfo)

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      const payload = {
        reason: reason || undefined,
        cloudinaryID: uploadedInfo?.publicId,
        cloudinaryURL: uploadedInfo?.url,
      };

      console.log("payload", payload)
      const res = await complianceService.submitForVerification(complianceId, payload);
      if (res?.success) {
        toast.success('Submitted for verification');
        onSubmitted?.();
        onClose();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message || 'Submit failed');
    } finally {
      setIsSubmitting(false);
      setReason("")
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">Send for Verification</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Reason (optional)</label>
            <textarea
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              placeholder="Add a reason or note"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Upload supporting document(Max size 3MB)</label>
            <div className="flex items-center gap-2">
              <input type="file" onChange={handleFileChange} className="flex-1" />
              <button
                onClick={handleUpload}
                disabled={!file || isUploading}
                className="inline-flex items-center px-3 py-2 rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50"
              >
                <Upload className="h-4 w-4 mr-2" />
                {isUploading ? 'Uploading...' : 'Upload'}
              </button>
            </div>
            {uploadedInfo?.url && (
              <p className="mt-2 text-xs text-green-700 break-all">Uploaded: {uploadedInfo.url}</p>
            )}
          </div>
        </div>

        <div className="flex justify-end gap-2 p-4 border-t border-gray-200">
          <button onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50"
          >
            <Send className="h-4 w-4 mr-2" />
            {isSubmitting ? 'Submitting...' : 'Send'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubmitVerificationModal;


